import moment from 'moment-timezone';

export const isPrivateServicesActive = config => {
  if (config) {
    // If no conf exist at all
    if (config.privateFleetsAvailable === undefined && config.privateServicesAvailable === undefined) return true;

    // If privateFleetsAvailable is not yet removed and privateServicesAvailable is not yet defined
    if (config.privateFleetsAvailable !== undefined && config.privateServicesAvailable === undefined)
      return config.privateFleetsAvailable;

    // If privateFleetsAvailable has been removed and privateServicesAvailable has been defined
    if (config.privateServicesAvailable !== undefined) return config.privateServicesAvailable;
  }

  return true;
};

/**
 * Removes leading and trailing whitespace from string.
 * @param {string} string
 * @returns {string} - Returns the string with leading and trailing whitespace removed.
 */
export const trimString = string => {
  if (typeof string !== 'string') return string;
  return string.trim();
};

/**
 * Download a file with a specific date format
 * @param {BlobPart} data - The data to be downloaded.
 * @param {{ prefix?: string, date: string, extension: Extensions, timezone: string }} options
 * @returns {void}
 */
export const downloadFileWithDate = (data, { prefix, date, extension, timezone = 'UTC' }) => {
  if (!data) throw new Error('Data is required to download a file.');
  if (!date) throw new Error('Date is required to download a file.');
  if (!extension) throw new Error('Extension is required to download a file.');

  const newBlob = new Blob([data]);

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const objectUrl = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = objectUrl;
  const convertedDate = moment.tz(date, timezone).format('DD-MM-YYYY-HH-mm-ss');
  link.download = `${prefix || 'invoice'}-${convertedDate}.${extension}`;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(data);
  }, 100);
};
